export const AutoCompleteField = {
  AddressLevel1: 'address-level1',
  AddressLevel2: 'address-level2',
  AddressLine1: 'address-line1',
  AddressLine2: 'address-line2',
  AddressLine3: 'address-line3',
  CCCsc: 'cc-csc',
  CCExpMonth: 'cc-exp-month',
  CCExpYear: 'cc-exp-year',
  CCName: 'cc-name',
  CCNumber: 'cc-number',
  Country: 'country',
  Email: 'email',
  Name: 'name',
  Organization: 'organization',
  PostalCode: 'postal-code',
  Tel: 'tel',
};
